import { GlobalConstants } from "../../data/GlobalConstants";
import { handleResponse } from "../../util/functions";
import { getToken } from "../../helpers/helperJWT";

const url = GlobalConstants.urlApi;

const findClienteNombre = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/clientes/findClienteNombre`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}


export const clientesService = {
    findClienteNombre
};